import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

export default function Header({ showBack = false, onBack, onLogout, title }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      localStorage.removeItem('foresight_auth');
      navigate('/login');
    }
  };

  return (
    <header className="border-b border-gray-200 bg-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5">
        <div className="flex items-center justify-between">
          {/* Left side - Back button + Logo + Title */}
          <div className="flex items-center gap-2.5">
            {showBack && (
              <Button 
                variant="ghost" 
                size="icon"
                onClick={handleBack}
                aria-label="Go back"
                className="flex-shrink-0 h-8 w-8"
              >
                <ArrowLeft className="w-5 h-5 text-gray-700" />
              </Button>
            )}
            
            {/* Logo Image */}
            <img 
              src="/logo.png" 
              alt="Foresight Logo" 
              className="w-9 h-9 rounded-full object-cover flex-shrink-0"
            />
            
            {/* App Name — split color, stacked because "Meet Schedule
                Predictor" doesn't fit alongside "Foresight" on mobile
                widths (no whitespace-nowrap on the second line). */}
            <div className="flex flex-col">
              <h1 className="text-base font-bold tracking-tight leading-tight">
                <span className="text-primary">Foresight</span>
                <span className="text-foreground ml-1.5">Meet Schedule Predictor</span>
              </h1>
              {title && (
                <p className="text-xs text-muted-foreground truncate max-w-[200px]">{title}</p>
              )}
            </div>
          </div>

          {/* Right side - Logout button (only shown when caller wired up logout) */}
          {onLogout && (
            <Button
              variant="ghost"
              onClick={handleLogout}
              className="text-gray-700 hover:text-gray-900 hover:bg-gray-100 text-sm"
              size="sm"
              data-testid="header-logout-button"
            >
              Log out
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}
